import { ComponentPropsWithoutRef } from "react";
import cn from "../../util/cn";

export type CellProps = {
  outline?: boolean;
} & ComponentPropsWithoutRef<"div">;

export const Cell = ({ className, children, outline = false, ...otherProps }: CellProps) => {
  return (
    <div
      className={cn(
        outline ? "outline outline-1 outline-gray-300" : "",
        "print:break-inside-avoid-page",
        className
      )}
      {...otherProps}
    >
      {children}
    </div>
  );
};

export const HeaderCell = ({ className, ...otherProps }: CellProps) =>
  Cell({
    className: cn("flex justify-center p-2 text-center font-semibold", className),
    outline: true,
    ...otherProps,
  });
